<template>
  <div class="container-fluid mt-2">
    <div class="row">
      <div class="col">
        <ul class="list-group">
          <li class="list-group-item" aria-current="true">
            <b>Name:</b> {{ player.Name }}
          </li>
          <li class="list-group-item" aria-current="true">
            <b>Model:</b> {{ player.Model }}
          </li>
          <li class="list-group-item" aria-current="true">
            <b>Serial:</b> {{ player.Serial }}
          </li>
          <li class="list-group-item" aria-current="true">
            <b>Group:</b> {{ player.ReportedGroup?.Name }}
          </li>
          <li class="list-group-item">
            <b>Presentation:</b> {{ player.Presentation.Name }}
          </li>
        </ul>
      </div>
      <div class="col">
        <ul class="list-group">
          <li class="list-group-item active" aria-current="true">SD card</li>
          <li class="list-group-item">CardUsed: {{ player.StorageInfo?.usedSize.toFixed(2) }} Gb</li>
          <li class="list-group-item">CardSize: {{ player.StorageInfo?.totalSize.toFixed(2) }} Gb</li>
          <li class="list-group-item">Usage: {{ player.StorageInfo?.usagePercentage.toFixed(2) }} % </li>
          <li class="list-group-item">Wear: ? </li>
        </ul>
      </div>
      <div class="col">
        <ul class="list-group">
          <li class="list-group-item active" aria-current="true">Autorun</li>
          <li class="list-group-item">
            Custom: {{ player.Autorun.IsCustom ? "yes" : "no" }}
          </li>
          <li class="list-group-item">Version {{ player.Autorun.Version }}</li>
        </ul>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col">
        <div class="card">
          <div class="card-title text-center"><h5>Time checks</h5></div>
          <div class="card-body">
            <time-dashboard :player="player" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import TimeDashboard from "@/components/player-timechecks.component.vue"

export default defineComponent({
    components: {
        TimeDashboard
    },
    props: {
        player: Object
    }
})
</script>

